import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here
import Config from "../../../Config.jsx";

import Localization from "../../../Localization.jsx"
import Helper from "../../../Helper.jsx"

import ElementFactory from "../../../views/stage/PlaybackElement/ElementFactory.jsx"

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stepper,
  Step,
  StepLabel,
  Grid,
  Icon,
  Typography,
  Box,
} from '@material-ui/core';

const STEP_ELEMENT_TYPE = 0;
const STEP_EDIT_ELEMENT = 1;
const STEP_ELEMENT_POSITION = 2;

class CreateElementDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      activeStep: STEP_ELEMENT_TYPE,
      elementType: -1,
    };
    autoBind(this);
  }

  handleClose() {
    this.setState({
      open: false,
      activeStep: STEP_ELEMENT_TYPE,
      elementType: -1,
    });
    this.state.open = false;
    this.state.activeStep = STEP_ELEMENT_TYPE;
    this.state.elementType = -1;
  }

  getSteps() {
    if (this.elementHasPosition(this.state.elementType)) {
      return [Localization.strings.ELEMENT_TYPE, Localization.strings.ELEMENT_POSITION, Localization.strings.EDIT_ELEMENT];
    }
    else {
      return [Localization.strings.ELEMENT_TYPE, Localization.strings.EDIT_ELEMENT];
    }
  }

  changeActiveStep(i) {
    this.setState({activeStep: i});
    this.state.activeStep = i;

    if (this.refs.elementFactory){
      this.refs.elementFactory.setState({
        activeView: i - 1,
      });
    }
  }

  handleElementTypeClicked(index) {
    this.setState({
      elementType: index,
    });
    this.state.elementType = index;
    this.changeActiveStep(1);
  }

  handleBackClicked() {
    let i = this.state.activeStep - 1;
    if (i <= 0) {
      i = 0;
      this.setState({ elementType: -1 });
      this.state.elementType = -1;
    }
    this.changeActiveStep(i);
  }

  handleNextClicked() {
    let steps = this.getSteps();
    let i = this.state.activeStep + 1;
    if (i === steps.length) {
      i = steps.length - 1;
    }
    this.changeActiveStep(i);
  }

  handleFinishClicked() {
    if (this.refs.elementFactory.validateInput() == true) {
      this.refs.elementFactory.createPlayback();
    }
  }

  elementHasPosition(type) {
    if (type >= 0) {
      return Config.GET_PLAYBACK_CONFIG(type)['hasPosition'];
    }
    else {
      return false;
    }
  }

  onUpdatePlayback() {
    this.handleClose();
  }

  render() {
    let playbackTime = 0;
    if (this.props.parent.refs.stageDetailView && this.props.parent.refs.stageDetailView.refs.stageMediaView) {
      playbackTime = this.props.parent.refs.stageDetailView.refs.stageMediaView.state.playbackTime;
    }
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth={true}
          maxWidth={'md'}
        >
          <DialogTitle>
            <Icon className="buttonIconLeft" style={{fontSize: '36px', verticalAlign:'middle'}}>
              {this.state.elementType > 0?
              Config.GET_PLAYBACK_CONFIG(this.state.elementType)['icon'] : "add"}
            </Icon>
            {(this.state.elementType > 0?
              Config.GET_PLAYBACK_CONFIG(this.state.elementType)['name']
              :
              Localization.strings.NEW_STAGE_ELEMENT) + " at " +  Helper.fToHHMMSS(playbackTime)
            }
          </DialogTitle>
          <DialogContent>
            <Stepper activeStep={this.state.activeStep}>
              {this.getSteps().map((label, index) => {
                return (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>

            <If condition={this.state.activeStep == STEP_ELEMENT_TYPE}>
              <Then>
                <Grid container spacing={2}>
                  {Config.GET_PLAYBACK_CONFIG(null).map( (row, i) => {
                    if (i > 0) {
                      return (
                        <Grid item key={i} xs={12} sm={6}>
                          <Button
                            size="large"
                            onClick={()=>this.handleElementTypeClicked(i)}
                          >
                            <Icon style={{fontSize: '48px'}}>
                              {Config.GET_PLAYBACK_CONFIG(i)['icon']}
                            </Icon>
                            <div style={{padding:'0 0 0 14px', textAlign:'left'}}>
                              <Typography>
                                <Box fontWeight="fontWeightBold">
                                  {Config.GET_PLAYBACK_CONFIG(i)['name']}
                                </Box>
                              </Typography>
                              <Typography variant="body2" style={{textTransform:'none'}}>
                                {Config.GET_PLAYBACK_CONFIG(i)['description']}
                              </Typography>
                            </div>
                          </Button>
                        </Grid>
                      );
                    }
                  })}
                </Grid>
              </Then>
            </If>
            <If condition={this.state.activeStep == STEP_EDIT_ELEMENT || this.state.activeStep == STEP_ELEMENT_POSITION}>
              <Then>
                <ElementFactory parent={this} root={this.props.root} ref="elementFactory"
                  elementType={this.state.elementType}
                  stageData={this.props.parent.state.selectedStage}
                />
              </Then>
            </If>
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Switch condition={this.state.activeStep}>
              <Case value={STEP_ELEMENT_TYPE}>
                <Button onClick={this.handleClose}>{Localization.strings.CANCEL}</Button>
              </Case>
              <Case value={STEP_EDIT_ELEMENT}>
                <Button onClick={this.handleBackClicked}>
                  {Localization.strings.BACK}
                </Button>
                <Button
                  variant="contained"
                  onClick={this.elementHasPosition(this.state.elementType)? this.handleNextClicked : this.handleFinishClicked}
                  color="primary"
                >
                  {this.elementHasPosition(this.state.elementType)? Localization.strings.NEXT : Localization.strings.FINISH}
                </Button>
              </Case>
              <Case value={2}>
                <Button onClick={this.handleBackClicked}>
                  {Localization.strings.BACK}
                </Button>
                <Button
                  variant="contained"
                  onClick={this.handleFinishClicked}
                  color="primary"
                >
                  {Localization.strings.FINISH}
                </Button>
              </Case>
            </Switch>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default CreateElementDialog;
